<template>
  <div class="administratorsList" >
    <div class="filters">
      <el-form :inline="true">
        <el-form-item>
          <el-select v-model="value"
          multiple 
          filterable
          clearable
          collapse-tags
          >
            <!-- <el-option key :label="$t('lang.villageall')" value="0"></el-option> -->
            <el-checkbox
                v-model="check"
                class="m-l-20"
                :indeterminate="value !== villageList.length"
                @change="selectAll"
              >
                全&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;选
              </el-checkbox>
            <el-option
              v-for="(item,index) in villageList"
              :key="index"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <!-- <el-form-item>
          <div class="collect">
            <span class="demonstration">费用期间:</span>
            <el-date-picker
              v-model="period"
              type="month"
              value-format="timestamp"
              placeholder="费用期间">
            </el-date-picker>
          </div>
        </el-form-item> -->
        <el-form-item label="费用期间">
          <el-date-picker  type="month" :placeholder="$t('lang.lab_startDate')"   value-format="timestamp" v-model="startTime"></el-date-picker>
            <span style="padding: 0 1px">至</span>
          <el-date-picker  type="month" :placeholder="$t('lang.lab_endDate')"  value-format="timestamp" v-model="endTime" ></el-date-picker>
        </el-form-item>
        <el-button type="primary" @click="commit">{{$t('lang.btn_search')}}</el-button>
        <el-button type="primary" @click="excelDownloadClick">{{$t('lang.btn_excelDl')}}</el-button>
      </el-form>
    </div>
    <el-card class="rateBase">
      <el-table
        :height="tableData.length > 0 ? require('@/config/enum').tableheight655 : require('@/config/enum').tableheight655"
        :data="tableData"
        :row-class-name="tableRowClassName"
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" width="55" v-if="this.administratorsListcheckbox"></el-table-column>
        <!-- <el-table-column
          type="index"
          :index="indexMethod"
          align="center"
          :label="$t('lang.lab_index')"
          width="100px"
        ></el-table-column> -->
        <!-- <el-table-column prop="staffName" v-if="this.latitude==3" label="管家" ></el-table-column> -->
        <el-table-column prop="feeName" :label="$t('lang.feePay.lab_feeConfigName')"></el-table-column>
          <el-table-column prop="receiveAmountCount2" label="应收金额">
            <template slot-scope="scope">{{scope.row.receiveAmountCount|rounding}}</template>
          </el-table-column>
          <el-table-column prop="paidAmountCount2" label="实收金额">
            <template slot-scope="scope">{{scope.row.paidAmountCount|rounding}}</template>
          </el-table-column>
          <el-table-column prop="revAmountCount2" label="欠款金额">
            <template slot-scope="scope">{{scope.row.revAmountCount|rounding}}</template>
          </el-table-column>
          <el-table-column prop="thisPeriodRate" label="收缴率"></el-table-column>
        </el-table-column>
      </el-table>
    </el-card>
  </div>
</template>

<script>
  import {
    excelDownload
  } from '../../../config/download.js'
/**
 *@ClassName:
 *@Description:管理员列表
 *@author:xubz
 *@Copyright:格众科技
 *@date:2021-12-15
 */
export default {
  name:'/manage/main.adminList',
  data() {
    return {
      startTime: '',
      endTime: '',
      latitude: '1',
      createTimeTs: '',
      period: '',
      input: '', // 关键字
      value: [], // 小区绑定值
      pageCount: 0, // 总页数
      pageNum: 1, // 第几页
      pageSize: 10, // 每页显示数
      tableData: [], // 列表数组
      villageList: [], // 小区下拉列表
      administratorsListcheckbox: require('@/config/enum')
        .administratorsListcheckbox, // 是否隐藏复选框
      total:{
                receiveAmountCount: "",
                paidAmountCount: "",
                revAmountCount: "",
                thisPeriodRate:"",
                receiveAmountCount1: "",
                paidAmountCount1: "",
                revAmountCount1: "",
                thisPeriodRate1: "",
                receiveAmountCount2: "",
                paidAmountCount2: "",
                revAmountCount2: "",
                thisPeriodRate2: "",
                receiveAmountCount3: "",
                paidAmountCount3: "",
                revAmountCount3: "",
                thisPeriodRate3: "",
                feeName: "合计"    
        }  
    }
  },
  created() {
    this.getDatePicker()
    this.gardens()
    this.value.push (this.$store.getters.gardenId) 
    this.collectionRateDetail()
  },
  filters: {
    rounding (value) {
      if (value == undefined || value == ''||value == null) {
          value = 0
      }
     return value.toFixed(2)
    }

  },
  methods: {
    selectAll (checked) {
      if (checked) {
        this.value = this.villageList.map(d => d.id)
      } else {
        this.value = []
      }
    },
     // 表格下载
     excelDownloadClick() {
        if (navigator.onLine) {
          // Excel表头
          const tHeader = [
            this.$i18n.t('lang.feePay.lab_feeConfigName'),
            this.$i18n.t('lang.lab_amountOwed'),
            this.$i18n.t('lang.lab_receivedAmountH'),
            "欠款金额",
            "收缴率"
          ]
          // 对应table数据的列字段名
          const filterVal = ['feeName', 'receiveAmountCount2', 'paidAmountCount2', 'revAmountCount2', 'thisPeriodRate'
          ]
          excelDownload(tHeader, filterVal, this.tableData, "收缴率统计表")
        } else {
          this.$message.error(this.$i18n.t('lang.lab_Online'))
        }
      },
      latitudeChange(){
          this.tableData=[]
      },
      getDatePicker() {
       let d = new Date()
      let year1, month1, day1
      [year1, month1, day1] = [d.getFullYear(), d.getMonth() + 12, 0]
      let date1 = new Date(year1, month1, day1).getTime()
      // this.datevalues.push(Date.parse(date1))
      this.endTime = date1
      // 前一天设定的日期时间
      let year2, month2, day2
      [year2, month2, day2] = [d.getFullYear(), d.getMonth(), 1]
      let date2 = new Date(year2, month2, day2).getTime()
      // this.datevalues.unshift(Date.parse(date2))
       this.startTime = date2
    },
    // ID序号功能
    indexMethod(index) {
      return (this.pageNum - 1) * this.pageSize + index + 1
    },
    tableRowClassName({ row, rowIndex }) {
      return rowIndex % 2 === 0 ? 'row-dark' : ''
    },
    handleSelectionChange(val) {
      this.multipleSelection = val
    },
    // 小区下拉
    gardens() {
      // let loading = this.$loading()
      // this.$get(`/gardens`).then(
      //   res => {
      //     loading.close()
      //     if (res && res.errCode === 0) {
      //       this.villageList = res.list
      //     }
      //   },
      //   error => {
      //     loading.close()
      //     this.$message.error(error)
      //   }
      // )
      let myGardens = [...this.$store.getters.userGardenList]
        let index = myGardens.findIndex(item => item.id === 0)
        if (index != -1) {
          myGardens.splice(index, 1)
        }
        this.villageList = myGardens
    
    },
    // 管理员列表
    collectionRateDetail() {
      debugger
       if(this.value.length==0){
          this.$message.info('请选择园区')
          return
       }
        if(this.startTime==''||this.startTime==undefined||this.endTime==''||this.endTime==undefined){
          this.$message.info('费用期间不能为空')
          return
       }
      let loading = this.$loading()
       let params = {
        gardenId:this.value.toString(),
        period: this.period,
        startTs: this.startTime,
        endTs: this.endTime
      }
      this.$get(
        `/selectCollectionRateStatistics/`,params
      ).then(
        res => {
          loading.close()
          if (res && res.errCode === 0) {
            this.tableData=res.list
          }
        },
        error => {
          loading.close()
          this.$message.error(error)
        }
      )
    },
    // 翻页
    handleCurrentChange(val) {
      this.pageNum = val
      this.collectionRateDetail()
    },
    // 切换每页显示多少数据
    handleSizeChange(val) {
      this.pageNum = 1
      this.pageSize = val
      this.collectionRateDetail()
    },
    commit() {
      this.pageNum = 1
      this.collectionRateDetail()
    }
  }
}
</script>

<style lang="scss" scope>


.rateBase .el-table--border th, .el-table__fixed-right-patch {
    border-bottom: 1px solid #bfc2c7;
}
.rateBase  .el-table--border th {
    border-right: 1px solid #c7c9cd;;
}
.collect{
  margin-left:40px;
}
</style>